module.exports = "<div ui-view class=\"d-flex flex-column\"></div>";


//////////////////
// WEBPACK FOOTER
// ./app/states/auth/auth.component.html
// module id = 952
// module chunks = 31